import { Popup } from './popup';

const popupCalls = { 
    init() {

        const menu = new Popup('#jsMenuWrap', '#jsOpenMenu', '#jsCloseMenu');
        menu.init();

        const account = new Popup('#jsAccountWrap', '#jsOpenAccount', '#jsCloseAccount');
        account.init();

        const cart = new Popup('#jsCartWrap', '#jsOpenCart', '#jsCloseCart');
        cart.init();

        const help = new Popup('#jsHelpWrap', '.jsOpenHelp', '#jsCloseHelp');
        help.init();

        const finder = new Popup('#jsFinderWrap', '.jsOpenFinder', '#jsCloseFinder');
        finder.init(); 

        const video = new Popup('#jsVideoWrap', '.jsOpenVideo', '#jsVideoClose'); 
        video.init();

        const filter = new Popup('#jsFiltersWrap', '#jsOpenFilter', '#jsCloseFilter'); 
        filter.init();

        const gallery = new Popup('#jsGalleryWrap', '#jsOpenGallery', '#jsGalleryClose'); 
        gallery.init();

        window.addEventListener('reset', () => {
        const gallery = new Popup('#jsGalleryWrap', '#jsOpenGallery', '#jsGalleryClose'); 
        gallery.init();
        })
    },
};

export default popupCalls;
